import convertArrayIntoNoUiSliderRange from './convert-array-into-no-ui-slider-range';
import updateTermSelectFromArray from './update-term-select-from-array';
import closestSelectValue from '../../../../../modules/closestSelectValue';
import cleansePositiveNumber from '../../../../../modules/cleansePositiveNumber';
import updateMileageSelectFromArray from './update-mileage-select-from-array';
const noUiSlider = require('nouislider');
const wNumb = require('wnumb');

export default class {
    /**
     * Class to handle rendering/syncing term/mileage/deposit for NewVehicle finance
     *
     * @param {NewVehicleObject} vehicle
     * @param {FinanceKeyObject} financeKeyObject
     */
    constructor(vehicle, financeKeyObject) {
        this.vehicle = vehicle;
        this.financeKeyObject = financeKeyObject;
    }

    getAllowedTerms() {
        if (typeof this.financeKeyObject.terms == 'undefined' || this.financeKeyObject.terms.length == 0) {
            return this.financeKeyObject.fallbackTerms;
        }
        return this.financeKeyObject.terms;
    }

    getAllowedDeposit() {
        if (typeof this.financeKeyObject.deposit.min == 'undefined' || typeof this.financeKeyObject.deposit.max == 'undefined' || this.financeKeyObject.deposit.length == 0) {
            return this.financeKeyObject.fallbackDeposit;
        }
        return this.financeKeyObject.deposit;
    }

    getAllowedMileages() {
        if (typeof this.financeKeyObject.mileages == 'undefined' || this.financeKeyObject.mileages.length == 0) {
            return this.financeKeyObject.fallbackMileages;
        }
        return this.financeKeyObject.mileages;
    }

    /**
     * Handles creating sliders, populating select elements or switching to fixed term
     * @param {*} customerParameters
     */
    renderTermInputs(customerParameters) {
        this.termSlider = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-term-slider');
        this.termSelect = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] select[name="term"]');
        this.termVariableText = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-term-text');
        this.termFixedText = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-term-text');
        const currentTerm = customerParameters.getTerm(this.financeKeyObject);
        let allowedTerms = this.financeKeyObject.getAllowedTerms();

        if (allowedTerms.length > 6) {
            if (allowedTerms.indexOf(24) >= 0) {
                allowedTerms = this.financeKeyObject.fallbackTerms;
                allowedTerms.unshift(24);
                if (this.financeKeyObject.getAllowedTerms().indexOf(60) >= 0 && allowedTerms.indexOf(60) === -1) {
                    allowedTerms.push(60);
                }
            } else {
                allowedTerms = this.financeKeyObject.fallbackTerms;
                if (this.financeKeyObject.getAllowedTerms().indexOf(60) >= 0 && allowedTerms.indexOf(60) === -1) {
                    allowedTerms.push(60);
                }
            }
        }

        // Determine if it's fixed term or not
        if (allowedTerms.length == 1) {
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-term').style.display = 'none';
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-term').style.display = 'block';
            // We can't render a slider with only 1 value, so mark it as false
            this.termSlider = false;
        } else {
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-term').style.display = 'block';
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-term').style.display = 'none';
        }

        // Setup Term select/slider
        if (this.termSlider) {
            // Need to convert the array of terms into an object keyed by the percentage the value between the min and max of the range
            const termSliderRanges = convertArrayIntoNoUiSliderRange(allowedTerms);
            noUiSlider.create(this.termSlider, {
                start: currentTerm,
                connect: "lower",
                snap: true,
                range: termSliderRanges,
                pips: {
                    mode: 'range',
                    density: 1,
                    filter: n => {
                        if (allowedTerms.indexOf(n) === -1) {
                            return -1;
                        }
                        return 1;
                    },
                    format: wNumb({
                        decimals: 0,
                    })
                }
            });

            // Link the term slider value to the term input, and trigger finance update event if changed
            this.termSlider.noUiSlider.on('slide', ( values, handle ) => {
                let term = customerParameters.setTerm(values[handle]);
                if (this.termSelect) {
                    closestSelectValue(term, this.termSelect);
                }
                if (this.termVariableText) {
                    this.termVariableText.innerHTML = this.financeKeyObject.formatTerm(term);
                }

                this.financeKeyObject.markFinanceAsModified();
                this.dispatchFinanceChangedEvent();
            });
        }

        if (this.termSelect) {
            updateTermSelectFromArray(allowedTerms, this.termSelect);
            closestSelectValue(currentTerm, this.termSelect);


            // Link the term input change to the slider, and trigger finance update event if changed
            $(this.termSelect).on('change.' + this.financeKeyObject.pseudoKey, () => {
                let term = customerParameters.setTerm(this.termSelect.options[this.termSelect.options.selectedIndex].value);
                if (this.termSlider) {
                    this.termSlider.noUiSlider.set(term);
                }
                if (this.termVariableText) {
                    this.termVariableText.innerHTML = this.financeKeyObject.formatTerm(term);
                }
                this.financeKeyObject.markFinanceAsModified();
                this.dispatchFinanceChangedEvent();
            });
        }

        if (this.termVariableText) {
            this.termVariableText.innerHTML = this.financeKeyObject.formatTerm(currentTerm);
        }

        if (this.termFixedText) {
            this.termFixedText.innerHTML = this.financeKeyObject.formatTerm(currentTerm);
        }
    }

    /**
     * Handles creating sliders, populating select elements or switching to fixed deposit
     * @param {*} customerParameters
     */
    renderDepositInputs(customerParameters) {
        this.depositSlider = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-deposit-slider');
        this.depositInput = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] input[name="deposit"]');
        this.depositVariableText = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-deposit-text');
        this.depositFixedText = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-deposit-text');
        const allowedDeposits = this.getAllowedDeposit();
        const currentDeposit = customerParameters.getDeposit(this);

        // Determine if it's fixed deposit or not
        if (allowedDeposits.min == allowedDeposits.max) {
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-deposit').style.display = 'none';
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-deposit').style.display = 'block';
            // We can't render a slider with only 1 value, so mark it as false
            this.depositSlider = false;
        } else {
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-deposit').style.display = 'block';
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-deposit').style.display = 'none';
        }

        // Setup Deposit input/slider
        if (this.depositSlider) {
            noUiSlider.create(this.depositSlider, {
                start: currentDeposit,
                connect: "lower",
                step: 25,
                range: {
                    'min': allowedDeposits.min,
                    'max': allowedDeposits.max
                },
                pips: {
                    mode: 'count',
                    values: 6,
                    density: 100,
                    format: wNumb({
                        decimals: 0,
                        prefix: '£'
                    })
                }
            });

            // Link the deposit slider value to the deposit input, and trigger finance update event if changed
            this.depositSlider.noUiSlider.on('slide', ( values, handle ) => {
                let deposit = customerParameters.setDeposit(values[handle]);
                if (this.depositInput) {
                    this.depositInput.value = this.financeKeyObject.formatDeposit(deposit);
                }
                if (this.depositVariableText) {
                    this.depositVariableText.innerHTML = this.financeKeyObject.formatDeposit(deposit);
                }
                this.financeKeyObject.markFinanceAsModified();
                this.dispatchFinanceChangedEvent();
            });
        }

        if (this.depositInput) {
            this.depositInput.value = this.financeKeyObject.formatDeposit(currentDeposit);

            // Link the term input change to the slider, and trigger finance update event if changed
            $(this.depositInput).on('input.' + this.financeKeyObject.pseudoKey, () => {
                let deposit = customerParameters.setDeposit(this.depositInput.value);
                if (this.depositSlider) {
                    this.depositSlider.noUiSlider.set(deposit);
                }
                if (this.depositVariableText) {
                    this.depositVariableText.innerHTML = this.financeKeyObject.formatDeposit(deposit);
                }
                this.financeKeyObject.markFinanceAsModified();
                this.dispatchFinanceChangedEvent();
            });
            $(this.depositInput).on('blur.' + this.financeKeyObject.pseudoKey, () => {
                this.depositInput.value = this.financeKeyObject.formatDeposit(cleansePositiveNumber(this.depositInput.value));
            });
        }

        if (this.depositVariableText) {
            this.depositVariableText.innerHTML = this.financeKeyObject.formatDeposit(currentDeposit);
        }

        if (this.depositFixedText) {
            this.depositFixedText.innerHTML = this.financeKeyObject.formatDeposit(currentDeposit);
        }
    }

    /**
     * Handles creating sliders, populating select elements or switching to fixed mileage
     * @param {*} customerParameters
     */
    renderMileageInputs(customerParameters) {
        this.mileageSlider = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-mileage-slider');
        this.mileageSelect = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] select[name="mileage"]');
        this.mileageVariableText = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-mileage-text');
        this.mileageFixedText = document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-mileage-text');
        const currentMileage = customerParameters.getMileage(this);
        const allowedMileages = this.getAllowedMileages();

        // Determine if it's fixed mileage or not
        if (allowedMileages.length == 1) {
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-mileage').style.display = 'none';
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-mileage').style.display = 'block';
            // We can't render a slider with only 1 value, so mark it as false
            this.mileageSlider = false;
        } else {
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .variable-mileage').style.display = 'block';
            document.querySelector('div[data-finance-calculator="'+ this.financeKeyObject.pseudoKey +'"] .fixed-mileage').style.display = 'none';
        }

        // Setup Term select/slider
        if (this.mileageSlider) {
            // Need to convert the array of mileages into an object keyed by the percentage the value between the min and max of the range
            const mileageSliderRanges = convertArrayIntoNoUiSliderRange(allowedMileages);

            const firstMileage =allowedMileages[0];
            const mileageCount = allowedMileages.length;
            const lastMileage = allowedMileages[mileageCount - 1];

            noUiSlider.create(this.mileageSlider, {
                start: currentMileage,
                connect: "lower",
                snap: true,
                range: mileageSliderRanges,
                pips: {
                    // mode: 'count',
                    // values: allowedMileages.length,
                    // density: 100,
                    // // Show pips in steps of 5000
                    // filter: a => a % 5000 == 0,
                    // format: wNumb({
                    //     decimals: 0,
                    // })
                    mode: 'range',
                    density: 1,
                    filter: n => {
                        if (allowedMileages.indexOf(n) === -1) {
                            return -1;
                        }
                        if (mileageCount <= 8) {
                            return 1;
                        }
                        if (n % firstMileage == 0 || n % lastMileage == 0) {
                            return 1;
                        }
                        return 0;
                    },
                }
            });

            // Link the mileage slider value to the mileage input, and trigger finance update event if changed
            this.mileageSlider.noUiSlider.on('slide', ( values, handle ) => {
                let mileage = customerParameters.setMileage(values[handle]);
                if (this.mileageSelect) {
                    closestSelectValue(mileage, this.mileageSelect);
                }
                if (this.mileageVariableText) {
                    this.mileageVariableText.innerHTML = this.financeKeyObject.formatMileage(mileage);
                }

                this.financeKeyObject.markFinanceAsModified();
                this.dispatchFinanceChangedEvent();
            });
        }

        if (this.mileageSelect) {
            updateMileageSelectFromArray(allowedMileages, this.mileageSelect);
            closestSelectValue(currentMileage, this.mileageSelect);

            // Link the mileage input change to the slider, and trigger finance update event if changed
            $(this.mileageSelect).on('change.' + this.financeKeyObject.pseudoKey, () => {
                let mileage = customerParameters.setMileage(this.mileageSelect.options[this.mileageSelect.options.selectedIndex].value);
                if (this.mileageSlider) {
                    this.mileageSlider.noUiSlider.set(mileage);
                }
                if (this.mileageVariableText) {
                    this.mileageVariableText.innerHTML = this.financeKeyObject.formatMileage(mileage);
                }
                this.financeKeyObject.markFinanceAsModified();
                this.dispatchFinanceChangedEvent();
            });
        }

        if (this.mileageVariableText) {
            this.mileageVariableText.innerHTML = this.financeKeyObject.formatMileage(currentMileage);
        }

        if (this.mileageFixedText) {
            this.mileageFixedText.innerHTML = this.financeKeyObject.formatMileage(currentMileage);
        }
    }

    /**
     * Call the global finance changed function to trigger finance to update
     */
    dispatchFinanceChangedEvent() {
        if (typeof window.financeChanged !== 'undefined') {
            window.financeChanged();
        }
    }

    syncTerm(term) {
        if (this.termVariableText) {
            this.termVariableText.innerHTML = this.financeKeyObject.formatTerm(term);
        }
        if (this.termFixedText) {
            this.termFixedText.innerHTML = this.financeKeyObject.formatTerm(term);
        }
        if (this.termSlider) {
            this.termSlider.noUiSlider.set(term);
        }
        if (this.termSelect) {
            closestSelectValue(term, this.termSelect);
        }
    }

    syncDeposit(deposit) {
        if (this.depositVariableText) {
            this.depositVariableText.innerHTML = this.financeKeyObject.formatDeposit(deposit);
        }
        if (this.depositFixedText) {
            this.depositFixedText.innerHTML = this.financeKeyObject.formatDeposit(deposit);
        }
        if (this.depositSlider) {
            this.depositSlider.noUiSlider.set(deposit);
        }
        if (this.depositInput) {
            this.depositInput.value = this.financeKeyObject.formatDeposit(deposit);
        }
    }

    syncMileage(mileage) {
        if (this.mileageVariableText) {
            this.mileageVariableText.innerHTML = this.financeKeyObject.formatMileage(mileage);
        }
        if (this.mileageFixedText) {
            this.mileageFixedText.innerHTML = this.financeKeyObject.formatMileage(mileage);
        }
        if (this.mileageSlider) {
            this.mileageSlider.noUiSlider.set(mileage);
        }
        if (this.mileageSelect) {
            closestSelectValue(mileage, this.mileageSelect);
        }
    }

    /**
     * When the finance type changes, we want to collect all of the currently selected values for this finance type. e.g. if customer starts on HP finance and selects 60 months, then changes to PCP which has a max of 48 months, we expect the slider and drop down for PCP to show 48 months, and the quote to show 48 months
     * @param {object} customerParameters
     */
    updateParameters(customerParameters) {
        const term = customerParameters.getTerm(this);
        customerParameters.setTerm(term);
        this.syncTerm(term);
        const deposit = customerParameters.getDeposit(this);
        customerParameters.setDeposit(deposit);
        this.syncDeposit(deposit);
        const mileage = customerParameters.getMileage(this);
        customerParameters.setMileage(mileage);
        this.syncMileage(mileage);
        return customerParameters;
    }

    /**
     * Sets the available term/mileage/deposit ranges for the finance key object
     * @param {object} constraint
     */
    constrain(constraint) {
        if (typeof constraint.Deposit !== 'undefined' && typeof constraint.Deposit.Minimum !== 'undefined' && typeof constraint.Deposit.Maximum !== 'undefined') {
            this.financeKeyObject.deposit = {
                min: constraint.Deposit.Minimum,
                max: constraint.Deposit.Maximum
            };
        }

        if (typeof constraint.Term !== 'undefined' && typeof constraint.Term.Values !== 'undefined') {
            this.financeKeyObject.terms = constraint.Term.Values;
            this.financeKeyObject.terms.sort((a, b) => {
                a = parseInt(a);
                b = parseInt(b);
                if (a < b) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
                return 0;
            });
        }

        if (typeof constraint.AnnualMileage !== 'undefined' && typeof constraint.AnnualMileage.Values !== 'undefined') {
            this.financeKeyObject.mileages = constraint.AnnualMileage.Values;
            this.financeKeyObject.mileages.sort((a, b) => {
                a = parseInt(a);
                b = parseInt(b);
                if (a < b) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
                return 0;
            });

        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-types/render-inputs.js